"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedDigitalAssetInstrumentSelector = exports.digitalAssetsListSelector = exports.digitalAssetSelector = void 0;
var _reselect = require("reselect");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var products = function products(state) {
  return state.apexCore.product.products;
};
var productAttributes = function productAttributes(state) {
  return state.productAttributes;
};
var digitalAssetsListSelector = exports.digitalAssetsListSelector = (0, _reselect.createSelector)([products, productAttributes], function (products, productAttributes) {
  return Object.values(Object.values(productAttributes || {}).filter(function (i) {
    return i.Type === 'DigitalAsset';
  }).reduce(function (acc, curr) {
    var prod = products.find(function (i) {
      return i.ProductId === curr.ProductId;
    }) || {};
    acc[curr.ProductId] = _objectSpread(_objectSpread({}, prod), curr);
    return acc;
  }, {}));
});
var digitalAssetSelector = exports.digitalAssetSelector = (0, _reselect.createSelector)([products, productAttributes, function (state, config) {
  return config;
}], function (products, productAttributes, config) {
  if (!products.length || !productAttributes) {
    return false;
  }
  var product = products.find(function (i) {
    return i.ProductId === config.ProductId;
  }) || {};
  var attributes = productAttributes[config.ProductId];
  if (product && attributes) {
    return _objectSpread(_objectSpread({}, product), attributes);
  }
  return false;
});
var selectedDigitalAssetInstrumentSelector = exports.selectedDigitalAssetInstrumentSelector = (0, _reselect.createSelector)([_instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols, function (state, config) {
  return config;
}], function (instruments, _ref) {
  var ProductId = _ref.ProductId;
  return instruments.find(function (i) {
    return i.Product1 === ProductId || i.Product2 === ProductId;
  });
});